import { T } from '@tribeplatform/react-components/i18n'

import { UsagesSection } from '../components/UsageSection.js'
import { CMSLimitCard } from './CMSLimitCard.js'
import { EmailLimitCard } from './EmailLimitCard.js'
import { MembersLimitCard } from './MembersLimitCard.js'
import { SeatsLimitCard } from './SeatsCard.js'
import { SpacesLimitCard } from './SpacesLimitCard.js'
import { StorageLimitCard } from './StorageLimitCard.js'
import { TranslationLimitCard } from './TranslationLimitCard.js'

export const ResourceUsagesSection = () => {
  return (
    <UsagesSection
      title={
        <h1 className="text-heading-md font-bold text-content">
          <T
            defaultMessage="Resource Overview"
            id="Admin.Billing.ResourceOverview"
          />
        </h1>
      }
      description={
        <p className="text-md text-content-muted">
          <T
            defaultMessage="Monitor resource allocation and utilization against your plan limits."
            id="Admin.Billing.ResourceOverviewDescription"
          />
        </p>
      }
    >
      <SpacesLimitCard />
      <CMSLimitCard />
      <MembersLimitCard />
      <SeatsLimitCard />
      <StorageLimitCard />
      <EmailLimitCard />
      <TranslationLimitCard />
    </UsagesSection>
  )
}
